import React from "react";

interface ICardTable {
  children: React.ReactNode;
}

export const CardTable = ({ children }: ICardTable) => {
  return <div className="card-table">{children}</div>;
};
